import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Automatically scrolls to the top of the page whenever the route changes.
 * Mount once inside <BrowserRouter>. Applies to every internal <Link>.
 * Uses `instant` behavior so the destination hero is always visible immediately.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Restore instantly to top on every route change
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
